/* Estados visuais compartilhados: carregando, vazio e aviso.
   Antes cada página tinha um spinner solto no meio do nada. */

export function Vazio({ icone = "bi bi-inbox", titulo, texto, tom = "dourado", acao }) {
    return (
        <div className="estado-bloco">
            <div className={`estado-icone ${tom === "verde" ? "verde" : ""}`}>
                <i className={icone}></i>
            </div>
            <h6 className="estado-titulo">{titulo}</h6>
            {texto && <p className="estado-texto">{texto}</p>}
            {acao}
        </div>
    );
}

export function Carregando({ texto = "Carregando..." }) {
    return (
        <div className="estado-bloco">
            <span className="spinner-border" style={{color: "#d4af37"}} role="status" aria-label={texto}></span>
            <p className="estado-texto">{texto}</p>
        </div>
    );
}

/* Esqueleto de KPI: a tela já nasce com a forma que vai ter */
export function EsqueletoCartoes({ quantidade = 4, heroi = false }) {
    return (
        <div className="cards-estatistica" aria-hidden="true">
            {heroi &&
                <div className="esqueleto-cartao card-heroi" style={{gridColumn: "1 / -1"}}>
                    <div className="esqueleto" style={{width: "42%", height: 11}}></div>
                    <div className="esqueleto" style={{width: "68%", height: 34}}></div>
                </div>
            }
            {Array.from({length: quantidade}).map((_, i) => (
                <div key={i} className="esqueleto-cartao">
                    <div className="esqueleto" style={{width: "60%", height: 10}}></div>
                    <div className="esqueleto" style={{width: "85%", height: 22}}></div>
                </div>
            ))}
        </div>
    );
}

/* Esqueleto de lista: mesma silhueta dos cartões de linha da tabela */
export function EsqueletoLista({ quantidade = 4 }) {
    return (
        <div className="pilha" aria-hidden="true">
            {Array.from({length: quantidade}).map((_, i) => (
                <div key={i} className="esqueleto-cartao">
                    <div className="esqueleto" style={{width: "62%", height: 16}}></div>
                    <div className="esqueleto" style={{width: "100%", height: 10}}></div>
                    <div className="esqueleto" style={{width: "45%", height: 10}}></div>
                    <div className="esqueleto" style={{width: "100%", height: 40, marginTop: 4}}></div>
                </div>
            ))}
        </div>
    );
}
